import { ol_LayerBase, ol_Collection, ol_Extent, ol_extent, ol_proj, ol_source, ol_layer } from "@omnia/exports/openlayers"
import { ICustomBasemap } from "../../map"
import { IOmniaSettings } from "../../types"
import { isArrayEmpty } from "../../utils/array"
import { IBasemapGroup } from "../types"
import { Basemap } from "./basemap"
import { BasemapGroup } from "./group"
import TileSource from "ol/source/Tile"
import TileGrid from "ol/tilegrid/TileGrid"

export function createCustomBasemaps(definitions: ICustomBasemap[], targetLayers: ol_Collection<ol_LayerBase>, settings: IOmniaSettings): IBasemapGroup {

    if (isArrayEmpty(definitions)) {
        return
    }

    const layer = new ol_layer.Tile()
    targetLayers.insertAt(0, layer)

    const projExtent = ol_proj.get("EPSG:3857").getExtent()

    const basemaps = definitions.map(cbm => createBasemap(layer, cbm, projExtent))

    return new BasemapGroup(
        "holding",
        basemaps,
        layer,
        settings.getSettings("customBasemap"),
        true,
        true
    )

}


function createBasemap(layer: ol_layer.Tile<TileSource>, cbm: ICustomBasemap, extent: ol_Extent) {

    let startResolution = ol_extent.getWidth(extent) / 256
    let resolutions = new Array(22)

    for (var i = 0, ii = resolutions.length; i < ii; ++i) {
        resolutions[i] = startResolution / Math.pow(2, i)
    }

    let tileGrid = new TileGrid({
        extent: cbm.Extent,
        origin: ol_extent.getTopLeft(extent),
        resolutions,
        minZoom: cbm.ZoomMin,
    })

    return new Basemap(
        cbm.Name,
        layer,
        () => new ol_source.XYZ({
            url: cbm.Url,
            tileGrid: tileGrid,
            projection: "EPSG:3857",
            minZoom: cbm.ZoomMin,
            maxZoom: cbm.ZoomMax
        }),
        cbm.Extent
    )

}
